module.exports = __webpack_public_path__ + "static/media/feishu_serve.4d4532fc.png";